const font = {
  screen: {
    size: {
      TINY: '8pt',
      SMALL: '10pt',
      MEDIUM: '11pt',
      LARGE: '14pt',
      XLARGE: '18pt',
    },
    lineHeight: {
      SMALL: '14pt',
      MEDIUM: '15pt',
    },
  },
  print: {
    size: {
      SMALL: '9pt',
      MEDIUM: '10pt',
      LARGE: '12pt',
      XLARGE: '18pt',
    },
    lineHeight: {
      SMALL: '12pt',
      MEDIUM: '13pt',
    },
  },
  mobile: {
    size: {
      SMALL: '9pt',
      MEDIUM: '11pt',
      LARGE: '12pt',
      XLARGE: '15pt',
    },
    lineHeight: {
      SMALL: '12pt',
      MEDIUM: '13pt',
    },
  },
};

export default font;



// WEBPACK FOOTER //
// ./theme/font.js